module.exports = __webpack_public_path__ + "static/media/blue-loader.081f5794.svg";